export const acciones_uiimh = [
    {
        "anio" : "Misión y Visión",
        "descripcion" : "Lograr que se hagan valer los derechos humanos para...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "../Mision"
            }
        ]
    },{
        "anio" : "Objetivo",
        "descripcion" : "Fortalecer y respetar por medio de acciones preventivas...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "../Objetivo"
            }
        ]
    },{
        "anio" : "Fotografias",
        "descripcion" : "Galeria fotografica de las actividades realizadas...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "../Galeria_fotos/"
            }
        ]
    },{
        "anio" : "Videos",
        "descripcion" : "Videos de las actividades realizadas...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "../Videos"
            }
        ]
    }
]